<template>
  <div class="wrapper">
    <AdminBreadCrumb :list="[parentPage]" title="マップレポート管理" />
    <v-card flat color="transparent" style="height: 85%">
      <v-card-text>
        レポート名：
        <strong>{{ mapReport.name }}</strong>
        <span class="padding">案件名：</span>
        <strong>{{ mapReport.insertionOrderName }}</strong>
        <span class="padding">抽出期間：</span>
        <strong>{{ mapReport.extractionPeriod }}</strong>
      </v-card-text>
      <div class="iframe">
        <iframe
          id="mapReport"
          :title="mapReport.name"
          :src="mapReport.url"
          width="100%"
          style="height: 100%"
          frameborder="0"
        />
      </div>
      <div class="usageGuide">
        <span>クリック地点</span>
        <img :src="imgUsageGuideClick" height="20" width="20" alt="" />
        <img :src="imgUsageGuideImp" height="25" width="150" alt="" />
      </div>
    </v-card>
  </div>
</template>

<script>
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeAdmin } from '@/mixins/setDrawerTypeAdmin'
import { setToolBarTypeAdmin } from '@/mixins/setToolBarTypeAdmin'
import { MapReportRepository } from '@/models/MapReport/MapReportRepository'
import AdminBreadCrumb from '@/components/Shared/BreadCrumb/AdminBreadCrumb'
import usageGuideImp from '@/assets/images/advertiser/map-report-usage-guide-imp.png'
import usageGuideClick from '@/assets/images/advertiser/map-report-usage-guide-click.png'

export default {
  name: 'AdminMapReport',
  components: {
    AdminBreadCrumb,
  },
  mixins: [accountInitializer, setDrawerTypeAdmin, setToolBarTypeAdmin],
  data() {
    return {
      mapReport: {},
      imgUsageGuideImp: usageGuideImp,
      imgUsageGuideClick: usageGuideClick,
    }
  },
  computed: {
    parentPage() {
      return { path: null, title: '承認管理' }
    },
  },
  created() {
    this.getMapReport()
  },
  methods: {
    async getMapReport() {
      this.mapReport = await MapReportRepository.findByIdForAdmin(
        this.$route.params.mapReportId,
      )
    },
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
  height: 100%;
}
.iframe {
  height: 100%;
}
.padding {
  margin-left: 20px;
}
.usageGuide {
  text-align: right;
  white-space: nowrap;
}
</style>
